import { Link, useLocation } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import { Breadcrumb } from '@components/breadcrumb';
import { IconButton } from '@components/icon-button';
import { IconCloseRegular } from '@components/icons/close-regular';
import { Stack } from '@components/stack';
import { useIsMobile } from '@hooks/use-is-mobile';

import { Header } from 'components/headers';
import { FavoriteToggle } from 'components/navigation/favorites';
import { useStore } from 'models/Provider';

export const ApplicationPageHeader = observer(({ application }) => {
  const { state } = useLocation();
  const isMobile = useIsMobile();
  let actions;
  if (state && state.onCloseUrl && !isMobile) {
    actions = (
      <Link to={state.onCloseUrl}>
        <IconButton icon={<IconCloseRegular />} />
      </Link>
    );
  }
  return (
    <Header
      breadcrumbs={<Crumbs application={application} />}
      actions={actions}
      mobileTitle={application.name}
    />
  );
});

const Crumbs = observer(({ application }) => {
  const { t } = useStore();
  return (
    <Stack orientation="horizontal" space={2} align="center">
      <Breadcrumb
        items={[
          { label: t('navigation.jobs'), link: '/jobs' },
          { label: application.job.title, link: `/jobs/${application.job.id}` },
          { label: application.name },
        ]}
      />
      <FavoriteToggle contentType="application" objectId={application.id} />
    </Stack>
  );
});
